import { render, staticRenderFns } from "./ModalChangePassword.vue?vue&type=template&id=e38b0694&scoped=true&"
import script from "./ModalChangePassword.vue?vue&type=script&lang=js&"
export * from "./ModalChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38b0694",
  null
  
)

export default component.exports